module.exports = __webpack_public_path__ + "static/media/mercado-modelo-cartao-acesso.58c92f37.jpg";